import de from '../../i18n/de'

export default function useTranslation() {
    const locale = 'de'

    function getT(key) {
        let value = key
        let text = (value.split('.').reduce((o, i) => {
            if (o) {
                return o[i]
            } else {
                return null
            }
        }, de))
        if (text)
            return text
        else {
            console.error('TRANSLATION_MISSING: ', value)
            return 'TRANSLATION_MISSING'
        }
    }

    function convertObjectToErrorArray(errors) {
        let messages = []
        if (errors.errorsT) {
            let key
            for (key in errors.errorsT) {
                messages.push(getT(errors.errorsT[key]))
            }
        } else {
            messages.push(getT('errors.defaultError'))
        }
        return messages
    }

    return {
        getT,
        convertObjectToErrorArray,
        locale,
    }
}
